import gql from 'graphql-tag';

const MACHINE_DATA_MAPS_QUERY = gql`
  query FieldLayerQuery(
    $fieldId: ID!
    $activityType: AgronomicActivityType!
    $seasonName: SeasonName!
    $cropId: ID!
    $seasonYear: Int!
    $dataLegitimacy: DataLegitimacyQuery
  ) {
    field(id: $fieldId) {
      name
      machineDataMaps(
        cropId: $cropId
        seasonName: $seasonName
        seasonYear: $seasonYear
        activityType: $activityType
        dataLegitimacy: $dataLegitimacy
      ) {
        maps {
          name
          assets {
            ... on RasterTileset {
              thumbnailUrl
              version
              tileUrlTemplate
              source
              legend {
                __typename
                items {
                  ... on CategoricalGeospatialAssetLegendItem {
                    __typename
                    color {
                      alpha
                      blue
                      green
                      red
                    }
                    label
                  }
                  ... on ContinuousGeospatialAssetLegendItem {
                  __typename
                    min
                    max
                    color {
                      alpha
                      blue
                      green
                      red
                    }
                  }
                }
                units
              }
            }
          }
        }
      }
    }
  }
`;

export enum AgronomicActivityType {
  PLANTING = 'PLANTING',
  HARVESTING = 'HARVESTING',
  PROTECTING = 'PROTECTING',
}

export enum SeasonName {
  SPRING = 'SPRING',
  SUMMER = 'SUMMER',
  FALL = 'FALL',
  WINTER = 'WINTER',
  SAFRINHA = 'SAFRINHA',
}

export enum DataLegitimacyQuery {
  ARTIFICIAL = 'ARTIFICIAL',
  LEGITIMATE = 'LEGITIMATE',
}

export interface MachineDataMapsQueryVariables {
  fieldId: string;
  activityType: AgronomicActivityType;
  seasonName: SeasonName;
  cropId: string;
  seasonYear: number;
  dataLegitimacy?: DataLegitimacyQuery;
}

export const getMachineDataMapsQuery = (variables: MachineDataMapsQueryVariables) => ({
  query: MACHINE_DATA_MAPS_QUERY,
  variables,
});
